import { render, staticRenderFns } from "./GeneralService.vue?vue&type=template&id=4c964a24&scoped=true"
import script from "./GeneralService.vue?vue&type=script&lang=js"
export * from "./GeneralService.vue?vue&type=script&lang=js"
import style0 from "./GeneralService.vue?vue&type=style&index=0&id=4c964a24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c964a24",
  null
  
)

export default component.exports